import { ActionTypes } from './constants';

const updatePendingParameters = (pendingParameters = {}) => ({
    type: ActionTypes.UPDATE_PENDING_PARAMETERS,
    payload: pendingParameters,
});

export default updatePendingParameters;
